import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { SHOP_EVENT_AVAILABILITY_LABEL } from '@common/constants/shopEvent';
import { PRODUCT_TYPE } from '@common/constants/products';

import { AvailabilityLabelWrapper } from './AvailabilityLabel.styled';

const AvailabilityLabel = ({ label, productType, noMargin }) => {
  const { t } = useTranslation();

  if (productType === PRODUCT_TYPE.SHOP_EVENT) {
    return (
      <AvailabilityLabelWrapper
        isRed={label === SHOP_EVENT_AVAILABILITY_LABEL.SOLDOUT}
      >
        {label === SHOP_EVENT_AVAILABILITY_LABEL.LOW &&
          t('shop.product.fewavailable.label', 'Wenig verfügbar')}
        {label === SHOP_EVENT_AVAILABILITY_LABEL.SOLDOUT &&
          t('shop.basket.soldOut.title', 'Ausverkauft')}
      </AvailabilityLabelWrapper>
    );
  }

  return (
    <AvailabilityLabelWrapper isRed noMargin={noMargin}>
      {t('product.unavailableLabel', 'nicht mehr verfügbar')}
    </AvailabilityLabelWrapper>
  );
};

AvailabilityLabel.defaultProps = {
  label: null,
  noMargin: false,
};

AvailabilityLabel.propTypes = {
  label: PropTypes.oneOf(Object.values(SHOP_EVENT_AVAILABILITY_LABEL)),
  productType: PropTypes.oneOf(Object.values(PRODUCT_TYPE)).isRequired,
  noMargin: PropTypes.bool,
};

export default AvailabilityLabel;
